// Profile Module
import { t } from '../core/i18n.js';
import { updatePageTitle, updateActiveNavigation } from './navigation.js';

/**
 * Show user profile page
 * TODO: Implement full profile functionality
 */
export function showProfile() {
    const mainContent = document.getElementById('main-content');
    if (!mainContent) return;
    
    updateActiveNavigation('profile');
    updatePageTitle('Profile');
    
    mainContent.innerHTML = `
        <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div class="bg-white shadow rounded-lg p-6">
                <h2 class="text-2xl font-semibold text-gray-900 mb-4">Profile</h2>
                <p class="text-gray-600">Profile functionality coming soon...</p>
            </div>
        </div>
    `;
    
    console.log('Show profile');
}
